// extracted by mini-css-extract-plugin
export var active = "components-account-card-__TokenStatus-module___active";
export var inactive = "components-account-card-__TokenStatus-module___inactive";
export var reasonDescription = "components-account-card-__TokenStatus-module___reasonDescription";
export var statusText = "components-account-card-__TokenStatus-module___statusText";
export var suspended = "components-account-card-__TokenStatus-module___suspended";